<div class="swipe-up-container">
    <div class="swipe-up"></div>
    <h4 class="swipe-up-label mt-2">Swipe Up!</h4>
</div>


